export enum ProductUnitCode {
  Bag = 'BG',
  Bottle = 'BO',
  Carton = 'CT',
  Centimeter = 'CMT',
  CubicMeter = 'MTQ',
  Day = 'DAY',
  Hour = 'HUR',
  Kilogram = 'KGM',
  Kilometer = 'KMT',
  Litre = 'LTR',
  Lot = 'LO',
  LumpSum = 'LS',
  Meter = 'MTR',
  Month = 'MON',
  Pack = 'PK',
  Pallet = 'PF',
  Piece = 'C62',
  SquareMeter = 'MTK',
  Tonne = 'TNE',
}
